import { useChat } from "@/contexts/ChatContext";
export default function ChatUnreadBadge() {
  const { summary } = useChat();
  return summary && summary.unreadCount > 0 ? (
    <span
      className="chat-badge ms-2"
      aria-label={`${summary.unreadCount} messages non lus`}
    >
      {summary.unreadCount > 99 ? "99+" : summary.unreadCount}
    </span>
  ) : null;
}
